import { defineMessages } from 'react-intl-next';

import {} from './index';
import type { SearchIssueStatusCategory } from '@atlassian/search-client';

export const i18n = defineMessages<SearchIssueStatusCategory>({
	OPEN: {
		id: 'search-page.filter.status.open',
		defaultMessage: 'Open',
		description: 'Open status for a Jira issue',
	},
	DONE: {
		id: 'search-page.filter.status.done',
		defaultMessage: 'Done',
		description: 'Done status for a Jira issue',
	},
});
